var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('edit-order-take-over-all-entries',{attrs:{"chapters":_vm.chapters}}),_c('edit-order-simple-input-container',{attrs:{"inputLines":_vm.chapters.basedata,"full-width":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }